import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from 'axios'
import axiosvue from 'vue-axios'
import VueSweetalert2 from 'vue-sweetalert2';
import ModalPeque from './components/ModalPeque.vue'
import ModalGrande from './components/ModalGrande.vue'
import ModalMediano from './components/ModalMediano.vue'
import 'sweetalert2/dist/sweetalert2.min.css';
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'




createApp(App).component('ModalMediano',ModalMediano).component('ModalPeque',ModalPeque).component('ModalGrande',ModalGrande).use(router).use(VueSweetalert2).use(store).use(axiosvue,axios).mount('#app')
